import store from '@/store';
import popup from '@/model/popup';
import PopupTariffLimits from '@/components/popup/PopupTariffLimits.vue';
import PopupAlert from '@/components/base/PopupAlert.vue';

const commonErrors = [
  {
    status: 422,
    message: 'Author account is blocked',
    text: 'Это действие невозможно выполнить, аккаунт владельца проекта заблокирован',
  },
  {
    status: 422,
    message: 'Project is archived',
    text: 'Это действие невозможно выполнить, проект перенесен в архив',
  },
  {
    status: 422,
    message: 'Project is draft',
    text: 'Ошибка! Обратитесь в техническую поддержку',
  },
];

let tariffErrorAdded = false;

export default {
  add(error) {
    // Ответа может не быть вовсе (сетевой сбой, таймаут, отменённый запрос) —
    // показывать через store такую ошибку нечем, а undefined в items сломал бы
    // геттеры err403/err404: они читают status у каждого элемента
    if (!error) return;

    const errMessage = error.data?.description;
    const common = commonErrors.find(
      e => e.status === error.status
        && (!e.message || e.message === errMessage),
    );

    if (!tariffErrorAdded && errMessage?.startsWith('Action is unavailable due to your tariff limits')) {
      const component = PopupTariffLimits;

      tariffErrorAdded = true;
      popup.add({ component, args: [errMessage] })
        .then(() => { tariffErrorAdded = false; })
        .finally(() => { this.clear(); });
    }

    if (!tariffErrorAdded && errMessage?.startsWith('Action is unavailable due to tariff limits')) {
      const component = PopupAlert;
      const args = ['Это действие невозможно выполнить из-за ограничений тарифа автора проекта'];

      tariffErrorAdded = true;
      popup.add({ component, args })
        .then(() => { tariffErrorAdded = false; })
        .finally(() => { this.clear(); });
    }

    if (common) {
      popup.addAlert(common.text).finally(() => { this.clear(); });
    } else {
      store.commit('error/add', error);
    }
  },
  clear() {
    store.commit('error/clear');
  },
};
